import persistReducer from 'redux-persist/es/persistReducer'
import createMigrate from 'redux-persist/es/createMigrate'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
import { getPersistConfig } from 'redux-deep-persist'
import expireIn from 'lib/redux-persist-transform'
import { MigrationManifest } from 'redux-persist'

import { pwaMigrations } from './migrations/migrations'
import data from './data'

const expireInValue = 30 * 60 * 1000
const expirationKey = 'pwaExpirationKey'

const persistConfig = getPersistConfig({
  key: 'pwa',
  storage,
  version: 2,
  migrate: createMigrate(pwaMigrations as unknown as MigrationManifest, { debug: false }),
  rootReducer: data,
  transforms: [expireIn(expireInValue, expirationKey, false)],
})

export const reducer = persistReducer(persistConfig, data)
